import { useNavigate, useRouter } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'

export default function NotFoundError() {
  const navigate = useNavigate()
  const { history } = useRouter()
  return (
    <div className='flex h-svh flex-col items-center justify-center gap-6 bg-muted px-4'>
      <div className='flex items-center gap-[10px]'>
        <div className='flex h-9 w-9 items-center justify-center rounded-md bg-sidebar-primary'>
          <span
            className='text-[18px] font-bold text-white'
            style={{ fontFamily: 'Fraunces' }}
          >
            G
          </span>
        </div>
        <span
          className='text-[22px] font-medium text-sidebar-foreground'
          style={{ fontFamily: 'Fraunces' }}
        >
          Glyde
        </span>
      </div>

      <h1
        className='text-[120px] leading-[120px] font-medium tracking-[-4px] text-[#F0EFEC]'
        style={{ fontFamily: 'var(--font-heading, Fraunces, serif)' }}
      >
        404
      </h1>

      <h2
        className='text-[28px] leading-none font-medium tracking-[-1px] text-sidebar-foreground'
        style={{ fontFamily: 'Fraunces' }}
      >
        Page not found
      </h2>

      <p className='text-center text-[14px] text-sidebar-ring'>
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>

      <div className='mt-1 flex items-center gap-3'>
        <Button
          onClick={() => navigate({ to: '/' })}
          className='h-auto rounded-md bg-sidebar-primary px-6 py-3 text-[14px] font-semibold text-white shadow-[0_2px_20px_#00000008] hover:bg-sidebar-primary'
        >
          Go to Dashboard
        </Button>
        <Button
          variant='outline'
          onClick={() => history.go(-1)}
          className='h-auto rounded-md border-sidebar-border px-6 py-3 text-[14px] font-medium text-muted-foreground hover:bg-white'
        >
          Go Back
        </Button>
      </div>
    </div>
  )
}
